/**
 * Test IDs for QA automation.
 */
export const testIds = {
  transactionsListTable: "transactions-list-table",
  transactionsListRateCell: "transactions-list-rate-cell",
  transactionsListTotalCell: "transactions-list-total-cell",
  transactionsListDocument: "transactions-list-document",
  transactionsListAddTransaction: "transactions-list-add-transaction",
} as const;
